import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CoreContentModule } from "@obg/ngx.core.content";
import { RouterModule } from "@obg/ngx.router";

import { PostModule } from "./post/post.module";
import { RssFeedContainer } from "./rss-feed.container";

const DIRECTIVES: any[] = [RssFeedContainer];

@NgModule({
	imports: [CommonModule, CoreContentModule, RouterModule, PostModule],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class RssFeedModule {}
